import telegramPng from '@/assets/images/telegram.png';

export const TASK_ICON_BY_TYPE: Record<string, string> = {
    0: telegramPng,
    1: telegramPng,
    2: telegramPng,
    3: telegramPng,
};